/*
    configurazione dello store di Redux
    lo store si occupa di gestire le action e di chiamare i reducer
*/
import {createStore, applyMiddleware, compose, combineReducers } from 'redux';
import rootReducer from '../reducers/index';
import thunk from 'redux-thunk';
import thunkMiddleware from 'redux-thunk';
import { browserHistory } from 'react-router';
import { routerMiddleware , syncHistoryWithStore, routerReducer } from 'react-router-redux';


export default function  configureStore(initialState){

    const baseHistory = browserHistory;
    const routingMiddleware = routerMiddleware(baseHistory)
    const reducer = rootReducer;

    const enhancer = compose(
        // Middleware you want to use in development:
        applyMiddleware(thunkMiddleware, routingMiddleware)
    );

    const store = createStore(reducer, enhancer);
    const history = syncHistoryWithStore(baseHistory, store);

    return {store, history};

}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js